module.exports = __webpack_public_path__ + "img/elburg-1.25c1b897.jpg";